









































































import {Component} from 'vue-property-decorator';
import {Getter} from "vuex-class";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import SmsFiltersFilter from "@/components/SMS/Filters/SmsFiltersFilter.vue";
import {ScrollButton} from "wings-ui-components";
import {SmsFilterItem} from "@/store/sms/filters/types";

@Component({components:{SmsFiltersFilter, ScrollButton}})
export default class SmsFilters extends BaseItemsPage<SmsFilterItem>{
  @Getter("smsFilters") smsFiltersResponse: any;

  private is_show_filter = false;
  currentSort= "id";
  currentSortOrder= "desc";
  tableFields = [
    'id',
    'partner',
    'condition',
    'text',
  ];

  getData(): any {
    return this.smsFiltersResponse;
  }

  tk(value: string) {
    return value ? value.replace(/!/, 'not') : value
  }

}
